import { CarouselAnalyticsComponentService } from '@analytics/feature';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CityService } from '@city/feature';
import { EnvironmentService } from '@core/feature';
import { CustomCmsProductReferencesComponent, CustomProduct } from '@product/const';
import { ProductListReviewsService } from '@reviews/data-access';
import { DeviceService, UserAgentService } from '@shared/services';
import { Image, ImageGroup, Product, ProductReference, ProductReferenceService, isNotNullable } from '@spartacus/core';
import { BREAKPOINT, CmsComponentData, CurrentProductService, ProductReferencesComponent } from '@spartacus/storefront';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  mergeMap,
  shareReplay,
  skip,
  switchMap,
  take,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { SwiperOptions } from 'swiper/types';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export abstract class CustomProductReferencesComponent extends ProductReferencesComponent implements OnInit, OnDestroy {
  config: SwiperOptions = {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 5,
    // TODO: такой опции больше нет
    // lazy: true,
  };
  isServer = this.environmentService.isPlatformServer;

  products$: Observable<CustomProduct[]>;
  items$: Observable<Observable<Product>[]>;
  deviceBreakpoint$: Observable<BREAKPOINT> = this.deviceService.breakpoint$;

  subscription = new Subscription();

  constructor(
    component: CmsComponentData<CustomCmsProductReferencesComponent>,
    current: CurrentProductService,
    protected referenceService: ProductReferenceService,
    protected deviceService: DeviceService,
    protected userAgentService: UserAgentService,
    protected cityService: CityService,
    protected carouselAnalyticsComponentService: CarouselAnalyticsComponentService,
    protected productListReviewsService: ProductListReviewsService,
    protected environmentService: EnvironmentService,
  ) {
    super(component, current, referenceService);
  }

  ngOnInit(): void {
    this.items$ = this.productCode$.pipe(
      withLatestFrom(this.componentData$),
      // почему тут появилась эта срань написано ниже
      // это все равно очень опасный прекол и есть шансы проебать карусельку
      // потому что клеан чистит все карусели, а лоад ниже грузит 1 карусель.
      // но это пока что лучшее из быстрых решений
      // и уж точно лучше коробки.
      tap(() => this.productReferenceService.cleanReferences()),
      tap(([productCode, data]) => {
        this.productReferenceService.loadProductReferences(
          productCode,
          data.productReferenceTypes,
          data?.maximumNumberProducts ?? +data.maximumNumberProducts,
        );
      }),
      mergeMap(([productCode, data]) => {
        return this.productReferenceService.getProductReferences(productCode, data.productReferenceTypes).pipe(
          filter((products) => Boolean(products)),
          // В коробке в сторе все карусели храянться в одном плоском списке,
          // поэтому каждый лоад саксес экшн любой из каруселек вызывает новый эмит селектора, ВСЕХ ебанных каруселек.
          // пиздец
          distinctUntilChanged(
            (a, b) => a.map((p) => p.target.code).join(',') === b.map((p) => p.target.code).join(','),
          ),
          map((references: ProductReference[]) => references.map((reference) => of(reference.target))),
        );
      }),
      map(this.filterBigImg),
      tap((items) => this.loadReviews(items)),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

    this.products$ = this.items$.pipe(switchMap((products$: Observable<CustomProduct>[]) => combineLatest(products$)));

    this.detectChangeCity();
    this.detectChangeProduct();
    const sizes = this.deviceService.sizes;
    this.config.breakpoints = {
      [1]: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
      },
      [375]: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      },
      [sizes.sm]: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 10,
      },
      [sizes.md]: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 10,
      },
      [sizes.lg]: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 10,
      },
    };
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onIndexChange(index: number): void {
    this.carouselAnalyticsComponentService.setOffset(index);
  }

  onSlidesPerViewChange(slidesPerView: number): void {
    this.carouselAnalyticsComponentService.setSlidesPerView(slidesPerView);
  }

  onIntersect(): void {
    this.carouselAnalyticsComponentService.setIntersected();
  }

  protected filterBigImg(items?: Observable<CustomProduct>[]): Observable<CustomProduct>[] {
    return items.map((item) =>
      item.pipe(
        map((product: CustomProduct) => {
          if (!product.images) {
            return product;
          }

          const newPrimary: ImageGroup = {};

          Object.keys(product.images.PRIMARY).forEach((key: string) => {
            if (key !== 'zoom') {
              newPrimary[key] = (product.images.PRIMARY as ImageGroup)[key] as Image;
            }
          });

          return {
            ...product,
            images: { ...product.images, PRIMARY: newPrimary },
          };
        }),
      ),
    );
  }

  protected loadReviews(items: Observable<CustomProduct>[]): void {
    combineLatest(items)
      .pipe(
        take(1),
        tap((products: CustomProduct[]) => {
          this.productListReviewsService.loadReviews(products.map((item) => item.code));
        }),
      )
      .subscribe();
  }

  protected get productCode$(): Observable<string> {
    return this.currentProductService.getProduct().pipe(
      filter(isNotNullable),
      map((product) => product?.code),
      // В коробке довольно замысловатый редьюсер, который любит складывать
      // разные карусельки в 1 список,
      // и тут по коробке нужен клеан
      // что вызывает доебетни лишних клеанов(по 4 на каждую карусель)..
      // поэтому клеан перреезжает неверх в инит
      // tap((_) => this.productReferenceService.cleanReferences()),
    );
  }

  private detectChangeCity(): void {
    this.subscription.add(
      this.cityService.activeBaseStoreCode$.pipe(skip(1)).subscribe(() => {
        this.referenceService.cleanReferences();
      }),
    );
  }

  private detectChangeProduct(): void {
    this.subscription.add(
      this.productCode$
        .pipe(distinctUntilChanged())
        .pipe(skip(1))
        .subscribe(() => {
          this.referenceService.cleanReferences();
        }),
    );
  }
}
